import type { AnyObject } from "@sveabank/cc-common";
import React from "react";
import { LoaderContext } from "../hoc/with-loader";
import type { PageData, PageHook } from "../types/utility";

export const usePageContext = <T extends AnyObject>(pageHook: PageHook<T>) => {
	const contextValue = React.useContext(LoaderContext);

	if (contextValue === undefined) {
		throw new Error("usePageContext must be used within a withLoader wrapper");
	}

	if (pageHook.name !== LoaderContext.displayName) {
		throw new Error(
			`Wrong context type (supplied: ${pageHook.name}, expected: ${
				LoaderContext.displayName || ""
			})`,
		);
	}

	return contextValue as PageData<T>;
};
